import { Link } from "react-router-dom";

export default function Register() {
  return (
    <div className="min-h-screen bg-[#0B0E14] text-white flex items-center justify-center px-6" data-testid="register-page">
      <div className="w-full max-w-sm space-y-6 text-center">
        <Link to="/" className="font-display font-black text-xl tracking-tight">SmartLinks</Link>
        <div className="space-y-2 pt-4" data-testid="signups-closed-notice">
          <i className="fa-solid fa-lock text-2xl text-slate-500" />
          <h1 className="text-2xl font-bold font-display">Sign-ups are closed</h1>
          <p className="text-sm text-slate-400">New accounts aren't open yet. If you already have one, log in below.</p>
        </div>
        <Link to="/login" data-testid="signups-closed-login-link">
          <button className="w-full bg-indigo-500 hover:bg-indigo-600 rounded-full h-11 font-bold transition-colors">Log In</button>
        </Link>
      </div>
    </div>
  );
}
